export default __webpack_public_path__ + "static/media/nine.61df5c6d.jpeg";